

// No Data Found Component
const NoDataFound = ({ 
  message = "No firm Found", 
  actionText = "Add Association",
  onActionClick,
  showCounter = false,
  leftCount = 983,
  rightCount = 123
}) => {
  return (
    <div style={{
      padding: '40px 20px',
      textAlign: 'center',
      minHeight: '123px',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      position: 'relative',
      border:"1px solid #ddd"
    }}>
      <div style={{
        fontSize: '14px',
        color: '#000000',
        marginBottom: '7px',
        fontWeight: '400'
      }}>
        {message}
      </div>
      
      {actionText && (
        <a
          href="#"
          onClick={(e) => {
            e.preventDefault();
            onActionClick && onActionClick();
          }}
          style={{
            color: '#1956F6',
            textDecoration: 'none',
            fontSize: '14px',
            fontWeight: '400',
            cursor: 'pointer'
          }}
          onMouseOver={(e) => e.target.style.textDecoration = 'underline'}
          onMouseOut={(e) => e.target.style.textDecoration = 'none'}
        >
          {actionText}
        </a>
      )}

      {showCounter && (
        <div style={{
          position: 'absolute',
          bottom: '20px',
          left: '50%',
          transform: 'translateX(-50%)',
          display: 'flex',
          gap: '4px',
          alignItems: 'center'
        }}>
          <span style={{
            backgroundColor: '#6c757d',
            color: 'white',
            padding: '2px 8px',
            borderRadius: '3px',
            fontSize: '12px',
            fontWeight: '600'
          }}>
            {leftCount}
          </span>
          <span style={{
            backgroundColor: '#007bff',
            color: 'white',
            padding: '2px 8px',
            borderRadius: '3px',
            fontSize: '12px',
            fontWeight: '600'
          }}>
            {rightCount}
          </span>
        </div>
      )}
    </div>
  );
};

export default NoDataFound;